import { apiClient } from './apiClient';

import type {
  ChecklistResponse,
  DocumentConfirmResponse,
  DocumentResponse,
  UploadUrlResponse,
} from '@/types/document.types';

export const documentApi = {
  /**
   * Get the document checklist for the current applicant.
   * Returns required/optional documents based on role/site policy.
   */
  getChecklist: (applicationId: string) =>
    apiClient.get<ChecklistResponse>(`/documents/checklist?applicationId=${applicationId}`),

  /**
   * Request a presigned S3 upload URL for a document.
   */
  getUploadUrl: (data: {
    applicationId: string;
    category: string;
    type: string;
    filename: string;
    contentType: string;
    fileSize: number;
    policyId?: string;
  }) => apiClient.post<UploadUrlResponse>('/documents/upload-url', data),

  /**
   * Confirm that a file was uploaded to S3 and trigger processing.
   */
  confirmUpload: (data: {
    applicationId: string;
    category: string;
    type: string;
    filename: string;
    fileKey: string;
    policyId?: string;
    checksum?: string;
  }) => apiClient.post<DocumentConfirmResponse>('/documents', data),

  /**
   * Reuse a previously uploaded document for the selected application.
   */
  reuseDocument: (data: { applicationId: string; sourceDocumentId: string; type: string }) =>
    apiClient.post<DocumentConfirmResponse>('/documents/reuse', data),

  /**
   * Delete a document (only allowed before verification).
   */
  deleteDocument: (documentId: string) => apiClient.delete(`/documents/${documentId}`),

  /**
   * Get document metadata by ID.
   */
  getDocument: (documentId: string) => apiClient.get<DocumentResponse>(`/documents/${documentId}`),
};
